// extracted by mini-css-extract-plugin
export default {"dragHandle":"SectionItems_dragHandle__xytjt","itemsDragging":"SectionItems_itemsDragging__RPxFK","item":"SectionItems_item__jYBuM","itemDragging":"SectionItems_itemDragging__Ph7T-"};